<template>
  <div>
    <div>
      <Table border
             ref="noticeTable"
             :columns="noticeColumns"
             :data="noticeDataNew"
             size="small"
             :height="500"
             @on-selection-change="onSelectionChange">
        <template slot-scope="{ row }"
                  slot="file">
          <Icon v-show="row.isAttachment=='1'"
                type="md-attach"
                style="font-size:20px" />
        </template>
        <template slot-scope="{ row }"
                  slot="subject">
          <div class="tableRow"
               v-html="row.subject"></div>
        </template>
        <template slot-scope="{ row }"
                  slot="body">
          <div v-html="row.body"></div>
        </template>
        <template slot-scope="{ row }"
                  slot="updated_date">
          <span>{{ row.updated_date?date.dateVal(row.updated_date, "YYYY/MM/DD HH:mm:ss"):'' }}</span>
        </template>
        <template slot="slot"
                  slot-scope="{ row }">
          <Button icon="ios-paper"
                  type="primary"
                  size="small"
                  @click="returnNoticeToDetail(row)">详情</Button>
          <Button icon="md-create"
                  type="warning"
                  size="small"
                  @click="editPop(row)"
                  style="margin-left:10px">编辑</Button>
          <Button icon="md-trash"
                  type="error"
                  size="small"
                  @click="deletPop(row)"
                  style="margin-left:10px">删除</Button>

        </template>
      </Table>
      <Row type="flex"
           justify="space-between"
           style="margin-top: 15px">
        <Col :xs="24"
             :sm="24"
             :lg="12">
        <Page :total="this.totalNum"
              style="margin-top: 0px;display: flex;justify-content: flex-start;margin-bottom:10px"
              @on-change="pageChange" />
        </Col>
        <Col :xs="24"
             :sm="24"
             :lg="12"
             class="btns"
             style="display:flex;justify-content:end;">
        <Button type="success"
                icon="md-add"
                :disabled="!addBtnShow"
                style="margin-right:10px"
                @click="add">追加</Button>
        <!-- <Button type="warning" icon="md-create" :disabled="!editBtnShow" style="margin-right:10px" @click="edit">编辑</Button> -->
        <!-- <Button type="error" icon="md-trash" :disabled="!delBtnShow" @click="delet">删除</Button> -->
        </Col>
      </Row>
    </div>

    <!-- 追加/编辑 弹框 -->
    <Modal v-model="noticeModal"
           :title="noticeModalTitle"
           width="800">
      <Form :model="noticeModalData"
            ref="noticeFormValidate"
            :rules="noticeRuleValidate"
            :label-width="120"
            label-position="left"
            label-colon>
        <FormItem label="主题"
                  prop="subject">
          <quill-editor v-model="noticeModalData.subject" />
        </FormItem>
        <FormItem label="公告正文"
                  prop="body">
          <quill-editor v-model="noticeModalData.body" />
        </FormItem>
        <FormItem label="过期日期"
                  prop="end_time">
          <DatePicker type="date"
                      format="yyyy/MM/dd"
                      v-model="noticeModalData.end_time"></DatePicker>
        </FormItem>
        <FormItem label="可见角色"
                  prop="show_roleList">
          <Select v-model="show_roleList"
                  multiple>
            <Option v-for="(item,index) in roleList"
                    :value="item.roleId"
                    :key="index">{{ item.roleName }}</Option>
          </Select>
        </FormItem>
        <div class="form-inline">
          <FormItem label="附件"
                    style="margin-bottom: 10px;">
            <Upload :action="action"
                    :show-upload-list="false"
                    :on-success="uploadSuccess">
              <Button icon="ios-cloud-upload-outline">点击上传</Button>
            </Upload>
          </FormItem>
        </div>
        <FormItem v-show="noticeModalData.isAttachment=='1'"
                  style="margin-bottom: 0px;">
          <span @click="downLoadFile(file)"
                class="file">{{ file.attach_name }}</span>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button style="margin-right: 10px"
                @click="cancel()">取消</Button>
        <Button type="primary"
                @click="handleSubmit()">确定</Button>
      </div>
    </Modal>

  </div>
</template>

<script>
import axios from 'axios'
import DateUtil from "../../../util/DateUtil";
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
export default {
  components: { quillEditor },
  data () {
    return {
      date: new DateUtil(),
      totalNum: 0, //table数据总条数
      pageInfo: {
        pageNo: 1, //页码
        pageSize: 10, //每页数据条数
      },
      addBtnShow: true,
      editBtnShow: false,
      delBtnShow: false,
      index: '',
      noticeData: [],
      noticeDataNew: [],
      noticeColumns: [
        {
          title: '序号',
          type: 'index',
          width: 60,
          align: 'center'
        },
        // {
        //   title: '附件',
        //   slot: 'file',
        //   width: 60,
        // },
        {
          title: '主题',
          slot: 'subject',
          minWidth: 150
        },
        {
          title: '修改时间',
          slot: 'updated_date',
          minWidth: 150
        },
        {
          title: '操作',
          align: "center",
          slot: "slot",
          width: 280,
        }
      ],
      noticeModal: false,
      noticeModalTitle: '新增',
      action: '/api/resource/upload',
      file: {},
      fileOrg: {},
      fileList: [],
      noticeModalData: {
        end_time: ''
      },
      noticeRuleValidate: {
        subject: [
          {
            required: true, trigger: 'blur', validator: (rule, value, callback) => {
              if (!this.noticeModalData.subject || this.noticeModalData.subject.length <= 0) {
                callback(new Error('请输入主题'));
              } else {
                callback();
              }
            }
          }
        ],
        body: [
          {
            required: true, trigger: 'blur', validator: (rule, value, callback) => {
              if (!this.noticeModalData.body || this.noticeModalData.body.length <= 0) {
                callback(new Error('请输入公告正文'));
              } else {
                callback();
              }
            }
          }
        ],
        // isScroll: [{ required: true, message: '请选择是否滚动', trigger: 'blur' }],
        end_time: [{ required: true, type: 'date', message: '请选择过期日期', trigger: 'blur' }],
        show_roleList: [{
          required: true, type: 'array', trigger: 'change', validator: (rule, value, callback) => {
            if (!this.show_roleList || this.show_roleList.length <= 0) {
              callback(new Error('请选择可见角色'));
            } else {
              callback();
            }
          }
        }],
      },
      noticeDataDel: [],
      show_roleList: [],
      roleList: [],
    }
  },
  created () {
    this.getData();
  },
  methods: {
    // 点击主题，跳转公告详情页
    returnNoticeToDetail (row) {
      this.$router.push({
        path: '/96D9F7FFBA3ECC423C7C703D2880C8FE723C91EC71D46066/A3FFBEBFDB713E27',
        query: { id: row.id }
      })
    },
    // 获取公告信息List
    getData () {
      axios.post('/announcement/selAnnouncementInfo', { ...this.pageInfo }).then(res => {
        if (res != null && res.data.length > 0) {
          this.noticeData = JSON.parse(JSON.stringify(res.data))
          this.noticeDataNew = JSON.parse(JSON.stringify(res.data))
          this.totalNum = Number(res.pageInfo.total)

        }
      })
    },
    // 页码改变
    pageChange (val) {
      this.pageInfo.pageNo = val
      this.getData()
    },
    // 按钮组控制
    onSelectionChange (selection) {
      if (selection.length < 1) {
        this.addBtnShow = true
        this.editBtnShow = false
        this.delBtnShow = false
      } else if (selection.length > 1) {
        this.addBtnShow = true
        this.editBtnShow = false
        this.delBtnShow = true
      } else if (selection.length = 1) {
        this.addBtnShow = true
        this.editBtnShow = true
        this.delBtnShow = true
        this.noticeData.forEach((item, index) => {
          if (item.id == selection[0].id) {
            this.index = index
          }
        });
      }
      this.noticeDataDel = JSON.parse(JSON.stringify(selection))
    },
    // 新增公告
    add () {
      this.cancel()
      this.noticeModal = true
      this.noticeModalTitle = '新增'
      axios.post('/remindModule/selectAllRemindRoleData', { remindId: '',isSysSetting : '1' }).then(res => {
        if (res) {
          this.roleList = res

        }
      })
    },
    // 编辑公告
    editPop (row) {
      this.noticeModal = true
      this.noticeModalTitle = '编辑'
      this.noticeModalData = JSON.parse(JSON.stringify(row))
      this.show_roleList = row.show_role ? row.show_role.split(",") : []
      axios.post('/announcement/selAttachmentInfo', { id: row.id }).then(res => {  // 根据公告id查附件
        if (res != null && res.length > 0) {
          this.fileOrg = JSON.parse(JSON.stringify(res[0]))
          this.file = JSON.parse(JSON.stringify(res[0]))
        }
      })
      axios.post('/remindModule/selectAllRemindRoleData', { remindId: '',isSysSetting : '1' }).then(res => {
        if (res) {
          this.roleList = res

        }
      })
    },
    // 删除公告
    deletPop (row) {
      this.$Modal.confirm({
        title: this.$notice('deletion'),
        content: '',
        onOk: () => {
          this.noticeDataDel.push(row)
          axios.post('/announcement/delAnnouncementInfo', this.noticeDataDel).then(res => {
            this.$Message.info('删除成功');
            this.noticeDataDel = []
            this.cancel()
            this.getData()
          })
        }
      })
    },
    uploadSuccess (response, file, fileList) {
      if (response.result == '0') {
        this.$Message.success('文件上传成功')
        this.file = {
          id: '',
          attach_name: file.name,
          resource_id: response.data
        }
        this.noticeModalData.isAttachment = '1' // '1'：有附件；  '0'：没有附件
      }
    },
    // 打开编辑弹框，若已有附件，则可下载附件
    downLoadFile (attach) {
      if (attach.resource_id != null) {
        axios({
          url: '/resource/download',
          method: 'post',
          data: { 'resourceId': attach.resource_id },
          responseType: 'blob'
        }).then(res => {
          var A = this.$store.getters.pageData.axiosHeader['content-disposition'].split('fileName=')[1]
          var FileSaver = require('file-saver')
          FileSaver.saveAs(new Blob([res]), decodeURIComponent(A))
        })
      }
    },
    handleSubmit () {
      this.$refs['noticeFormValidate'].validate((valid) => {
        if (valid) {
          this.$Modal.confirm({
            title: this.$notice('sureSave'),
            content: '',
            onOk: () => {
              this.noticeModalData.show_role = this.show_roleList.join(",")
              this.noticeModalData.end_time ? this.noticeModalData.end_time = this.date.dateVal(this.noticeModalData.end_time) : null
              if (this.noticeModalTitle == '新增') {
                axios.post('/announcement/addAnnouncementInfo', this.noticeModalData).then(res => { // 新增公告
                  if (this.noticeModalData.isAttachment == '1') {
                    this.file.id = res.id
                    this.fileList.push(this.file)
                    axios.post('/announcement/addAttachment', this.fileList).then(res => {  // 新增公告附件
                    })
                  }
                  this.$Message.info(this.$t('Save_Successful'));
                  this.cancel()
                  this.getData()
                  this.$refs['noticeFormValidate'].resetFields();
                })
              } else if (this.noticeModalTitle == '编辑') {
                var me = this
                axios.post('/announcement/updAnnouncementInfo', this.noticeModalData).then(res => { // 修改公告
                  if (this.fileOrg.resource_id && (this.fileOrg.resource_id != this.file.resource_id)) { // 如果文件重新上传，再调修改公告附件接口
                    axios.post('/announcement/delAttachmentInfo', [{ id: this.noticeModalData.id }]).then(res => {  // 先删除公告附件
                      me.file.id = me.noticeModalData.id
                      me.fileList.push(me.file)
                      axios.post('/announcement/addAttachment', me.fileList).then(res => {  // 再新增公告附件
                        me.cancel()
                        me.getData()
                      })
                    })
                  } else {
                    if (this.fileOrg.resource_id != this.file.resource_id) { // 如原无附件，现有上传，则新增公告附件
                      me.file.id = me.noticeModalData.id
                      me.fileList.push(me.file)
                      axios.post('/announcement/addAttachment', me.fileList).then(res => {
                      })
                    }
                    me.cancel()
                    me.getData()
                  }
                  this.$Message.info(this.$t('Save_Successful'));
                  // this.$nextTick(() => {
                  //   this.$refs['noticeFormValidate'].resetFields();
                  // })
                })
              }
            }
          });
        }
      })
    },
    cancel () {
      this.$refs['noticeFormValidate'].resetFields();
      delete this.noticeModalData.isAttachment
      this.show_roleList = []
      this.fileList = []
      this.file = {
        id: '',
        attach_name: '',
        resource_id: ''
      }
      this.noticeModal = false
      this.addBtnShow = true
      this.editBtnShow = false
      this.delBtnShow = false
    },
  }
}
</script>

<style lang="less" scoped>
/deep/ .ivu-table-cell {
  max-height: 107px;
}
.file {
  height: 22px;
  line-height: 22px;
  margin: 2px 4px 2px 0;
  padding: 0 8px;
  border: 1px solid #e8eaec;
  border-radius: 3px;
  background: #f7f7f7;
  font-size: 12px;
  vertical-align: middle;
  opacity: 1;
  overflow: hidden;
  cursor: pointer;
}
@media screen and (max-width: 768px) {
  .btns {
    margin-top: 15px;
    justify-content: center !important;
  }
}
@media (max-width: 992px) {
  /deep/ .ivu-modal {
    width: auto !important;
    margin: 10px;
  }
}
@media screen and (max-width: 576px) {
  /deep/ .ivu-form-item {
    display: flex !important;
    flex-direction: column !important;
  }
  /deep/ .ivu-form-item-label {
    width: 100% !important;
  }
  /deep/ .ivu-form-item-content {
    margin-left: 0px !important;
  }
  .form-inline {
    /deep/ .ivu-form-item {
      flex-direction: row !important;
    }
    /deep/ .ivu-form-item-label {
      width: 120px !important;
    }
  }
}
/deep/.ivu-table-cell .tableRow h2 {
  font-size: 14px !important;
  font-weight: normal !important;
}
</style>


// WEBPACK FOOTER //
// src/components/process/SystemSettings/AnnouncementNoticeSetting.vue